module.exports = __webpack_public_path__ + "assets1783936157458/img/user.54e3bd0f.svg";